import { db } from '@/firebase'

export default {
    getDescuentos({ commit, rootState }) {
        let negocio = rootState.app.negocioGest;
        let devolver = [];
        return db.collection('negocios').doc(negocio).collection('descuentos').get()
            .then((res) => {
                res.forEach(doc => {
                    let aux = doc.data();
                    aux.id = doc.id;
                    devolver.push(aux);
                });
                commit('setDescuentosArray', devolver)
            })
    },
    addDescuento({ rootState }, desc) {
        let negocio = rootState.app.negocioGest
        let id = desc.id;
        delete desc.id;
        var ref = null
        if (id) {
            ref = db.collection('negocios').doc(negocio).collection('descuentos').doc(id).set(desc, { merge: true })
        } else {
            ref = db.collection('negocios').doc(negocio).collection('descuentos').add(desc)
        }
        return ref;
    },
    deleteDescuento({ commit, rootState }, item) {
        let negocio = rootState.app.negocioGest;
        return db.collection('negocios').doc(negocio).collection('descuentos').doc(item.id).delete();
    },
    changeActivo({ rootState }, payload) {
        const negocio = rootState.app.negocioGest;
        return db.collection('negocios').doc(negocio).collection('descuentos')
            .doc(payload.id).get()
            .then((desc) => {
                var res = [];
                if (desc.exists) {
                    var ref = desc.ref;
                    return ref.set({ activo: payload.activo }, { merge: true })
                } else {
                    return Promise.reject("Descuento no encontrado")
                }
            })
    }
}